import { get } from "lodash-es";
import { getTemplateResources } from "../../repositories/TemplatesRepositorie";

type Props = {
	TemplateId: number | null;
	setTemplateAttachmentsList: Function;
	setIsLoadingTemplateResourcesList: (isLoading: boolean) => void;
	setErrorTemplateResourcesList: (err: string) => void;
};

export const useSearchTemplateResources = ({
	TemplateId,
	setTemplateAttachmentsList,
	setIsLoadingTemplateResourcesList,
	setErrorTemplateResourcesList,
}: Props) => {
	return async () => {
		setIsLoadingTemplateResourcesList(true);
		const res = await getTemplateResources(TemplateId as number);
		if (res.ok) {
			// swv-cmms only uses Attachments (table index 0 from GetTemplateResources)
			const TemplateAttachmentsList = get(res, "data.tables[0].rows", []);
			setTemplateAttachmentsList(TemplateAttachmentsList);
			setIsLoadingTemplateResourcesList(false);
		} else {
			setIsLoadingTemplateResourcesList(false);
			setErrorTemplateResourcesList(res.message);
		}
	};
};
